import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../common/api";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  InputAdornment,
  makeStyles,
  MenuItem,
  TextField,
  Typography
} from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { set } from "react-ga";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  option: {
    fontSize: "0.75rem",
    minHeight: "auto",
    '&[aria-selected="true"]': {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    },
    '&[data-focus="true"]': {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
  },
  input: {
    fontSize: "0.75rem"
  }
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Task = ({ id, isProductive }) => {
  const [task, setTask] = useState({
    parent: { parent: { id: 0 }, parent_id: 0 },
    sales_task: { id: 0, name: "" },
    sales_task_id: 0,
    parent_id: 0,
    category_id: 0,
    is_sellable: 0,
    id: 0
  });
  const [tasks, setTasks] = useState({ groups: [], subgroups: [] });
  const [salesTasks, setSalesTasks] = useState({ options: [], loading: false });
  const [categories, setCategories] = useState([]);
  const [ivaTypes, setIvaTypes] = useState([]);
  const [sapTasksGroups, setSapTasksGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: ""
  });
  const token = localStorage.getItem("userToken");
  const classes = useStyles();

  const getTask = async (newId = "") => {
    const idReq = newId ? newId : id;
    try {
      const response = await axios.get(`${api.tasksAdmin().get(idReq)}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      response.data.materials_account_cost =
        response.data.materials_account_cost == "0" ||
        response.data.materials_account_cost == 0
          ? false
          : true;
      response.data.workforce_account_cost =
        response.data.workforce_account_cost == "0" ||
        response.data.workforce_account_cost == 0
          ? false
          : true;
      response.data.total_account_cost =
        response.data.total_account_cost == "0" ||
        response.data.total_account_cost == 0
          ? false
          : true;
      response.data.is_sellable =
        response.data.is_sellable == "0" || response.data.is_sellable == 0
          ? false
          : true;

      setTask(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  const getGroups = async () => {
    try {
      const response = await axios.get(
        `${api.tasksAdmin().groups(isProductive == 1 ? 1 : 0)}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      const groups_response = response.data;
      setTasks({ groups: groups_response, subgroups: [] });
    } catch (error) {
      console.error(error);
    }
  };
  const getCategories = async () => {
    try {
      const response = await axios.get(`${api.categories().getAll()}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCategories(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const getIvaTypes = async () => {
    try {
      const response = await axios.get(`${api.iva_conditions}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIvaTypes(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const getSapTasksGroups = async () => {
    try {
      const response = await axios.get(`${api.sap_tasks_groups}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      var filteredGroups = response.data.filter(
        group => group.is_productive == isProductive
      );

      setSapTasksGroups(filteredGroups);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setSaving(true);
    var formData = new FormData();
    formData.append("category_id", task.category_id ? task.category_id : "");
    formData.append("parent_id", task.parent_id ? task.parent_id : "");
    formData.append("name", task.name ? task.name : "");
    formData.append("hansa_code", task.hansa_code ? task.hansa_code : "");
    formData.append("description", task.description ? task.description : "");
    formData.append("iva_buy_id", task.iva_buy_id ? task.iva_buy_id : "");
    formData.append("iva_sell_id", task.iva_sell_id ? task.iva_sell_id : "");
    if (task.is_sellable == 0) {
      formData.append(
        "sales_task_id",
        task.sales_task_id ? task.sales_task_id : ""
      );
    }
    formData.append("comments", task.comments ? task.comments : "");
    formData.append(
      "workforce_account_cost",
      task.workforce_account_cost ? 1 : 0
    );
    formData.append(
      "materials_account_cost",
      task.materials_account_cost ? 1 : 0
    );
    formData.append("total_account_cost", task.total_account_cost ? 1 : 0);
    formData.append(
      "sap_task_group_id",
      task.sap_task_group_id ? task.sap_task_group_id : ""
    );
    formData.append("is_sellable", task.is_sellable ? 1 : 0);
    formData.append("is_productive", isProductive == 1 ? 1 : 0);
    let url = api.tasksAdmin().post();
    if (task.id > 0) {
      formData.append("id", task.id);
      formData.set("_method", "PATCH");
      url = api.tasksAdmin().patch(task.id);
    }

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      });
      if (response.status === 200) {
        //setTask(response.data);
        setSnackbar({
          open: true,
          severity: "success",
          message: "Tarea guardada correctamente"
        });
        if (response.data && response.data.task) {
          getTask(response.data.task.id);
        }
      }
    } catch (error) {
      let error_message = "Error al guardar la tarea";
      if (error.response && error.response.data) {
        for (const key in error.response.data.errors) {
          error_message += ` ${error.response.data.errors[key]}`;
        }
      }
      console.error(error);
      setSnackbar({
        open: true,
        severity: "error",
        message: error_message
      });
    }
    setSaving(false);
  };
  useEffect(() => {
    const getInitialData = async () => {
      await getGroups();
      await getCategories();
      await getIvaTypes();
      await getSapTasksGroups();
      if (id > 0) await getTask();
      if (id == 0) setLoading(false);
    };
    getInitialData();
  }, [id]);

  useEffect(() => {
    const groups = tasks.groups;

    if (task.parent_id > 0) {
      const group = groups.find(group =>
        group.children.find(subgroup => subgroup.id == task.parent_id)
      );
      if (group) {
        setTasks({ ...tasks, subgroups: group.children });
      }
    }
  }, [task.parent_id]);

  const handleTaskSearch = async (event, value) => {
    if (value.length > 2) {
      setSalesTasks(prev => ({ ...prev, loading: true }));
      const token = localStorage.getItem("userToken");
      try {
        const response = await axios.get(
          api.work_order().tasks_autocomplete(value, 1),
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        setSalesTasks(prev => ({
          ...prev,
          options: response.data.filter(
            task => task.id != id && task.is_sellable == 1
          ),
          loading: false
        }));
      } catch (error) {
        console.error(error);
        setSalesTasks(prev => ({ ...prev, loading: false }));
      }
    }
  };
  return (
    <div>
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <div className="row">
            <Snackbar
              open={snackbar.open}
              autoHideDuration={10000}
              onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
              <Alert
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                severity={snackbar.severity}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
            <div className="col-md-12">
              <h5>
                {task.id == 0
                  ? isProductive == 1
                    ? "Nueva tarea"
                    : "Nuevo articulo"
                  : task.name}
              </h5>
            </div>

            <TextField
              id="parent_id.parent_id"
              name="parent_id"
              value={task.parent.parent_id}
              select
              margin="normal"
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setTask({
                  ...task,
                  parent: { ...task.parent, parent_id: e.target.value },
                  category_id: tasks.groups.find(
                    group => group.id == e.target.value
                  ).category_id
                });
                setTasks({
                  ...tasks,
                  subgroups: tasks.groups.find(
                    group => group.id == e.target.value
                  ).children
                });
              }}
              inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ width: 80 }}>
                      Grupo
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            >
              {tasks.groups
                .filter(g => g.children.length > 0)
                .map(subgroup => (
                  <MenuItem
                    style={{ fontSize: "12px" }}
                    key={subgroup.id}
                    value={subgroup.id}
                  >
                    {subgroup.name}
                  </MenuItem>
                ))}
            </TextField>

            <TextField
              id="parent_id"
              name="parent_id"
              value={task.parent_id}
              select
              margin="normal"
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setTask({ ...task, parent_id: e.target.value })}
              inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ width: 80 }}>
                      Subgrupo
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            >
              {tasks.subgroups.map(subgroup => (
                <MenuItem
                  style={{ fontSize: "12px" }}
                  key={subgroup.id}
                  value={subgroup.id}
                >
                  {subgroup.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="name"
              name="name"
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      Nombre
                    </Typography>
                  </InputAdornment>
                )
              }}
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setTask({ ...task, name: e.target.value })}
              value={task.name}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            />
            <TextField
              id="hansa_code"
              name="hansa_code"
              disabled
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      Código
                    </Typography>
                  </InputAdornment>
                )
              }}
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setTask({ ...task, hansa_code: e.target.value })}
              value={task.hansa_code}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            />
            <TextField
              id="sap_code"
              name="sap_code"
              disabled
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      Código SAP
                    </Typography>
                  </InputAdornment>
                )
              }}
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              //onChange={e => setTask({ ...task, hansa_code: e.target.value })}
              value={task.sap_code || "SIN CODIGO"}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            />
            {/*<TextField
              id="sap_dimension"
              name="sap_dimension"
              disabled
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      Dimensión SAP
                    </Typography>
                  </InputAdornment>
                )
              }}
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              //onChange={e => setTask({ ...task, hansa_code: e.target.value })}
              value={task.sap_dimension || "SIN CODIGO"}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            />
            */}
            <TextField
              id="category_id"
              name="category_id"
              value={task.category_id}
              select
              margin="normal"
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setTask({ ...task, category_id: e.target.value })}
              inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ width: 80 }}>
                      Categoría
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            >
              {categories.map(category => (
                <MenuItem
                  style={{ fontSize: "12px" }}
                  key={category.id}
                  value={category.id}
                >
                  {category.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="description"
              name="description"
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      Descripción
                    </Typography>
                  </InputAdornment>
                )
              }}
              className="col-md-12 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setTask({ ...task, description: e.target.value })}
              value={task.description}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            />
            <TextField
              id="iva_buy_id"
              name="iva_buy_id"
              margin="normal"
              select
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      IVA Compra
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setTask({ ...task, iva_buy_id: e.target.value })}
              value={task.iva_buy_id}
              inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
            >
              {ivaTypes.map(ivaType => (
                <MenuItem
                  style={{ fontSize: "0.75rem" }}
                  key={ivaType.id}
                  value={ivaType.id}
                >
                  {ivaType.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="iva_sell_id"
              name="iva_sell_id"
              margin="normal"
              select
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      IVA Venta
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setTask({ ...task, iva_sell_id: e.target.value })}
              value={task.iva_sell_id}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            >
              {ivaTypes.map(ivaType => (
                <MenuItem
                  style={{ fontSize: "12px" }}
                  key={ivaType.id}
                  value={ivaType.id}
                >
                  {ivaType.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="sap_task_group_id"
              name="sap_task_group_id"
              margin="normal"
              select
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      Grupo SAP
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
              className="col-md-3 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e =>
                setTask({ ...task, sap_task_group_id: e.target.value })
              }
              value={task.sap_task_group_id}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            >
              {sapTasksGroups.map(sapTaskGroup => (
                <MenuItem
                  style={{ fontSize: "12px" }}
                  key={sapTaskGroup.id}
                  value={sapTaskGroup.id}
                >
                  {sapTaskGroup.description} ({sapTaskGroup.sap_code})
                </MenuItem>
              ))}
            </TextField>
          </div>
          <div className="row mt-1">
            {isProductive == 1 && (
              <FormControlLabel
                control={
                  <Checkbox
                    name={"is_sellable"}
                    id={"is_sellable"}
                    checked={task.is_sellable}
                    value={task.is_sellable}
                    onChange={e =>
                      setTask({
                        ...task,
                        is_sellable: e.target.checked
                      })
                    }
                    className="pt-0"
                  />
                }
                label={<Typography variant="caption">Es venta?</Typography>}
                labelPlacement="start"
                className="ml-0 mr-1"
                style={{ alignItems: "normal" }}
              />
            )}
            {isProductive == 1 && task.id > 0 && task.sales_task_id > 0 && (
              <TextField
                id="sales_task_id"
                name="sales_task_id"
                margin="normal"
                disabled
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ minWidth: 50 }}>
                        Tarea de venta
                      </Typography>
                    </InputAdornment>
                  )
                }}
                className="col-md-4 mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                value={task.sales_task.name}
                inputProps={{
                  style: { fontSize: "0.75rem" }
                }}
              />
            )}
            {isProductive == 1 &&
              (task.is_sellable == 0 || task.is_sellable == "0") &&
              (task.id == 0 || (task.id > 0 && !task.sales_task_id)) && (
                <Autocomplete
                  className="col-md-4"
                  id={`tasks-autocomplete`}
                  options={salesTasks.options}
                  getOptionLabel={option => option.name}
                  getOptionSelected={(option, value) => option.id === value.id}
                  loading={tasks.loading}
                  onInputChange={handleTaskSearch}
                  onChange={(event, value) =>
                    setTask({
                      ...task,
                      sales_task_id: value ? value.id : "",
                      sales_task_name: value ? value.name : ""
                    })
                  }
                  autoComplete
                  noOptionsText={
                    <Typography variant="caption">Sin resultados</Typography>
                  }
                  includeInputInList
                  classes={{
                    option: classes.option
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      placeholder="Ingrese una tarea de venta"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {tasks.loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                        classes: {
                          input: classes.input
                        }
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  )}
                />
              )}
            <FormControlLabel
              control={
                <Checkbox
                  name={"workforce_account_cost"}
                  id={"workforce_account_cost"}
                  checked={task.workforce_account_cost ? true : false}
                  value={task.workforce_account_cost ? true : false}
                  onChange={e =>
                    setTask({
                      ...task,
                      workforce_account_cost: e.target.checked,
                      materials_account_cost: false,
                      total_account_cost: false
                    })
                  }
                  className="pt-0"
                />
              }
              label={
                <Typography variant="caption">Es mano de obra?</Typography>
              }
              labelPlacement="start"
              className="ml-0 mr-1"
              style={{ alignItems: "normal" }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name={"materials_account_cost"}
                  id={"materials_account_cost"}
                  checked={task.materials_account_cost ? true : false}
                  value={task.materials_account_cost ? true : false}
                  onChange={e =>
                    setTask({
                      ...task,
                      materials_account_cost: e.target.checked,
                      workforce_account_cost: false,
                      total_account_cost: false
                    })
                  }
                  className="pt-0"
                />
              }
              label={<Typography variant="caption">Es material?</Typography>}
              labelPlacement="start"
              className="ml-0 mr-1"
              style={{ alignItems: "normal" }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name={"total_account_cost"}
                  id={"total_account_cost"}
                  checked={task.total_account_cost ? true : false}
                  value={task.total_account_cost ? true : false}
                  onChange={e =>
                    setTask({
                      ...task,
                      total_account_cost: e.target.checked,
                      materials_account_cost: false,
                      workforce_account_cost: false
                    })
                  }
                  className="pt-0"
                />
              }
              label={<Typography variant="caption">Es total?</Typography>}
              labelPlacement="start"
              className="ml-0 mr-1"
              style={{ alignItems: "normal" }}
            />
            <TextField
              id="comments"
              name="comments"
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 50 }}>
                      Comentarios
                    </Typography>
                  </InputAdornment>
                )
              }}
              className="col-md-12 mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setTask({ ...task, comments: e.target.value })}
              value={task.comments}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            />
          </div>
          <div className="row mt-1">
            <Button
              disabled={saving}
              className="mr-2"
              variant="contained"
              color="primary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={e => {
                handleSubmit(e);
              }}
            >
              {saving ? "Guardando..." : "Guardar"}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={() =>
                (window.location.href =
                  isProductive == 1 ? "/tasks" : "/tasks-non-productive")
              }
            >
              Cancelar
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
export default Task;
